import classes from './DisplayBoxRight.module.css'

export default function DisplayBoxRight({children}) {
    return <div className={classes.box_right}>
        {children}
    </div>
}